export default {
  goToPlatform: 'Go to platform'
}



// WEBPACK FOOTER //
// ./src/App/i18n/strings/home/landing/en.js